import { AppBar, FormControlLabel, makeStyles, Switch, withStyles } from "@material-ui/core";
import { styled } from "@material-ui/styles";
import { useIO, useModel } from "@type-r/react";
import { Button, Flex, Loading, navigate, Page, PrimaryButton, SelectSortBy, Toolbar } from "lqx-react/lib";
import * as React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { RowH1 } from "../../../../../common";
import { AddFilter } from "../components/search-bar/search-bar";
import { ImportTemplatesList } from "./import-templates-list";
import { ImportTemplatesState } from "./models/import-template-store";

const sortOptions = {
    createdOn: "Created On",
    updatedOn: "Updated On"
}

export const ImportTemplatesPage = () => {
    const classes = useStyles();
    const state = useModel(ImportTemplatesState);

    const isReady = useIO(async () => {
        await getData();
        state.initialize()
    }, []);

    const getData = async () => {
        await state.getFiltered(state.mapToQuery())
            .then(async (templates) => {
                state.importTemplateCards.set(templates.items.filter(t => t.isUserDefined) as any);
            });
    }

    const dataLoaded = useIO(async () => {
        if (isReady) {
            await getData()
        }
    },
        [state.filter['_changeToken'], state.sort['_changeToken'], state.isDefault, state.isStandard]
    );

    return (
        <Page maxWidth={false} header={
            <Flex center>
                <RowH1 className={classes.title}>Import Templates</RowH1>
            </Flex>
        }
            top={
                <AppBar position="static" color="secondary">
                    <Toolbar>
                        <StyledFilterBar filter={state.filter} filterAllPlaceholder="Filter by Company Name, Import Template Name, or Asset Type" />
                        <StyledFormControlLabel
                            control={
                                <Switch
                                    onChange={(e, c) => state.isDefault = c}
                                    color="primary"
                                />
                            }
                            label={"Default"}
                            labelPlacement="start"
                        />
                        <StyledFormControlLabel
                            control={
                                <Switch
                                    onChange={(e, c) => state.isStandard = c}
                                    color="primary"
                                />
                            }
                            label={"Standard"}
                            labelPlacement="start"
                        />
                        <SelectSortBy $attr={state.sort.$.attr} $asc={state.sort.$.asc} options={sortOptions} />
                        {Can(UserEntitlementCatalogs.ViewCreateNewImportModelButton) &&
                            <PrimaryButton
                                style={{ marginLeft: "auto" }}
                                onClick={() => navigate("import-templates/new")}>
                                Create Import Template
                            </PrimaryButton>
                        }
                    </Toolbar>
                </AppBar>
            }>
            {isReady && dataLoaded ?
                <ImportTemplatesList importTemplateCards={state.importTemplateCards}></ImportTemplatesList> : <Loading />}
        </Page>);
};

const useStyles = makeStyles({
    title: {
        padding: '20px 0',
        color: '#3d6889',
        fontSize: '24px'
    }
});

const StyledFilterBar = styled(AddFilter)({
    width: '650px',
    alignItems: 'center',
    padding: '4px',
})

const StyledFormControlLabel = withStyles({
    label: {
        fontSize: '13px',
        fontFamily: 'Montserrat',
        fontWeight: 500,
        color: 'grey',
    },
    labelPlacementStart: {
        margin: '0 !important'
    }
})(FormControlLabel)
